import { showErrorSnackbar, showSuccessSnacbar } from '@components/shared-layouts/Snackbar/helper'
import { CustomSubmitButton } from '@components/shared-ui-components/Buttons'
import CustomDropdownField from '@components/shared-ui-components/CustomFields/CustomDropdownField'
import { Paper } from '@mui/material'
import { startMedSAM2Propagation } from '@services/dashboardService'
import { FormikHelpers, useFormik } from 'formik'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

const initialDefaultValues = {
  model_name: 'MedSAM 2 Propagation',
}

function MedSAM2PropagationPage() {
  const { projectId } = useParams();
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const dropdownData = [
    { value: 'MedSAM 2 Propagation', label: 'MedSAM 2 Propagation' }
  ];

  const handleSubmit = async (values: any, actions: FormikHelpers<any>) => {
    if (!projectId) {
      showErrorSnackbar('Project ID is missing');
      return;
    }

    try {
      setIsSubmitting(true);
      const response = await startMedSAM2Propagation(projectId);
      showSuccessSnacbar(response?.data?.message || 'MedSAM 2 Propagation started successfully');
      
      // Navigate to the list page
      // navigate(`/${project_type}/operations/${projectId}/medsam-2-propagation/list`);
    } catch (err: any) {
      console.error('Error starting MedSAM 2 Propagation:', err);
      const errorMessage = err?.error?.message || 'Failed to start MedSAM 2 Propagation';
      showErrorSnackbar(errorMessage);
    } finally {
      setIsSubmitting(false);
      actions.setSubmitting(false);
    }
  };
  
  const formik = useFormik({
    initialValues: initialDefaultValues,
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  const {
    handleSubmit: handleSub,
    values,
    touched,
    errors,
    handleChange,
  } = formik;

  return (
    <Paper
      elevation={3}
      sx={{
        padding: '20px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '0px'
      }}
    >
      <h4>MedSAM 2 Propagation</h4>
      <form onSubmit={handleSub} style={{ display: "inline-grid" }}>
        <CustomDropdownField
          label={'Model Name'}
          name={'model_name'}
          value={values['model_name']}
          onChange={handleChange}
          error={Boolean(touched['model_name'] && errors['model_name'])}
          sx={{ mb: 2 }}
          disabled={true}
          dropdownData={dropdownData}
          formik={formik}
        />
        
        <CustomSubmitButton btnName="Start" isSubmitting={isSubmitting} />
      </form>
    </Paper>
  );
}

export default MedSAM2PropagationPage;

